import React from 'react';
import { Config } from './config';
import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { HttpLink } from '@apollo/client/link/http';
import { ErrorLink } from '@apollo/client/link/error';
import LoadingSpinner from './components/LoadingSpinner';
import { Typography } from '@mui/material';
import { AuthProviderProps } from 'oidc-react';

export function CustomApolloProvider({ config, oidcConfig, children }: { config: Config; oidcConfig: AuthProviderProps; children: React.ReactNode }) {
  const getToken = () => {
    const item = sessionStorage.getItem(`oidc.user:${oidcConfig.authority}:${oidcConfig.clientId}`);
    if (item === null) return null;

    return JSON.parse(item).access_token;
  };

  const httpLink = new HttpLink({ uri: '/server/api/GraphQL' });

  const authMiddleware = new ApolloLink((operation, forward) => {
    var token = getToken();
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
        'GraphQL-Preflight': 1,
      },
    }));

    return forward(operation);
  });

  const errorLink = new ErrorLink(({ error }) => {
    const networkError = (error as any)?.networkError;

    if (networkError && networkError.statusCode === 401) {
      //auth.signIn();
    }
  });

  const client = new ApolloClient({
    devtools: { enabled: config.env === 'Development' },
    link: ApolloLink.from([errorLink, authMiddleware, httpLink]),
    defaultOptions: {
      watchQuery: { notifyOnNetworkStatusChange: false },
    },
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            getUsers: {
              merge(existing, incoming) {
                return incoming;
              },
            },
          },
        },
      },
    }),
  });

  if (!getToken())
    return (
      <>
        <LoadingSpinner />
        <Typography align="center">Logger inn</Typography>
      </>
    );

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
